import React, { useRef, useState, useCallback, useEffect } from 'react'

import { Helmet } from 'react-helmet-async';

import {
    Box,
} from '@mui/material';

import { useNavigate, Link } from 'react-router-dom';

import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import DataGridToolbar from '../../common/DataGridToolbar';
import DataGridTable from '../../common/DataGridTable';
import DataGridRowActionMenu from '../../common/DataGridRowActionMenu';
import CommonRestricted from '../../common/CommonRestricted';

import { icons } from '../../common/CommonIcons';
import {
    useDataGridParams,
    dataGridFilterTypes,
    dataGridFilterTypesProps
} from '../../../hooks/useDataGridParams';
import { useSchedulers, schedulerTypes, targetTypes, schedulerConfigs } from '../../../hooks/api/useSchedulers';

import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

import RequestStatusBadge from './section/RequestStatusBadge';

export default function ListRequests({
    routeType
}) {

    const navigate = useNavigate();
    const { promptMessage } = useSystemPrompt();
    const { list, remove } = useSchedulers({ schedulerType: schedulerTypes.schedulerRequest });

    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.scheduler.id, scopeTypes.scheduler.request.id)

    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const gridRef = React.createRef();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            if (!props?.sortInfo) {
                props.sortInfo = {
                    id: `ax_createdatetime`,
                    dir: -1
                }
            }

            const result = await list(props)

            return {
                data: result?.data?.scheduler_requests,
                count: result?.data?.total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }

    }

    useEffect(() => {

        defineColumnsView()

    }, [])

    const defineColumnsView = () => {
        defineColumns([
            {
                name: 'id',
                header: 'Request Id',
                renderValue: ({ value, cellProps }) => {

                    let url = getRoute(`settings/scheduler/request/view/${cellProps?.data?.id}`)

                    return getRenderColumnLink(url, value.toUpperCase())

                }
            },
            {
                name: 'action',
                header: 'Action',
                textAlign: 'center',
                // renderValue: ({ value, cellProps }) => {

                //     let url = getRoute(`scheduler/request/view/${cellProps?.data?.id}`)

                //     return getRenderColumnLink(url, value.toUpperCase())
                // },
                // filter: {
                //     type: dataGridFilterTypes.select,
                //     props: {
                //         placeholder: 'Any',
                //         dataSource: schedulerFlowDirectionTypes.map(i => ({
                //             id: i.id,
                //             label: i.label
                //         }))
                //     }
                // }
            },
            {
                name: 'target',
                header: 'Target',
                // renderValue: ({ value, cellProps }) => {

                //     if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                //         return getRenderColumnTextDisplay(value)
                //     }

                //     let path = getRoute(`scheduler/log/update/${cellProps.data.id}`);

                //     return getRenderColumnLink(path, value)

                // }
            },
            {
                name: 'module', header: 'Module'
            },
            {
                name: 'request_ref', header: 'Ref'
            },
            {
                name: 'integration_id',
                header: 'Integration Id',
                renderValue: ({ value, cellProps }) => {
                    return getRenderColumnTextDisplay(value)
                },
                filter: {
                    type: dataGridFilterTypes.select,
                    props: {
                        placeholder: 'Any',
                        dataSource: schedulerConfigs.schedulerIntegrationTypes.map(i => ({
                            id: i.id,
                            label: i.id
                        }))
                    }
                }
            },
            {
                name: 'attempt_no', header: 'Attempt No.'
            },
            {
                name: 'source_id', header: 'Source Id'
            },
            {
                name: 'destination_id', header: 'Destination Id'
            },
            {
                name: 'attempt_status',
                header: 'Status',
                renderValue: ({ cellProps, value }) => {

                    return (
                        <RequestStatusBadge
                            item={cellProps.data}
                        />
                    )

                    // if (cellProps.data.attempt_no === "0") {
                    //     return getRenderColumnTextDisplay(`Waiting`)
                    // }

                    // return getRenderColumnBooleanDisplay(value, ["Success", "Failed"], ["primary", "default"], "")
                }
            },
        ])
    }

    // const handleDelete = async () => {

    //     try {

    //         let result = await remove({ ids: selectedIds, targetType: targetTypes.schedulerRequest })

    //         promptMessage(true, result?.message)
    //         setRefreshDataGrid(val => val + 1)

    //     } catch (error) {
    //         promptMessage(false, error?.message)
    //     }

    // }

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            // if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
            //     props.push({
            //         displayIconName: icons.plus,
            //         onClick: () => {
            //             navigate(getRoute("scheduler/request/new"));
            //         }
            //     })
            // }

            return props
        }

        // const getActionOnClick = () => {

        //     let handleFunction = null

        //     if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
        //         handleFunction = handleDelete
        //     }

        //     return handleFunction
        // }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                // actionOnClickRemove={
                //     getActionOnClick()
                // }
                actionMenus={[]}
            />
        )
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        minHeight: 600
                    },
                    pageSizes: [20, 50, 100],
                    defaultLimit: 10,
                    defaultSkip: 0,
                    // checkboxColumn:
                    //     isPermissionAllow({ functionType: functionTypes.remove.id }),
                    checkboxColumn: false,
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )
    }

    const getBreadcumbActionMenus = () => {

        let props = []

        if (isPermissionAllow({ scopeType: scopeTypes[scopeIds.scheduler.id].task.id, functionType: functionTypes.pageList.id })) {
            props.push(
                {
                    displayText: "Manage Tasks",
                    onClick: () => {
                        navigate(getRoute(`settings/schedulers`))
                    }
                },
                {
                    displayText: "Manage Logs",
                    onClick: () => {
                        navigate(getRoute(`settings/scheduler/logs`))
                    }
                },
                {
                    displayText: "Manage Console",
                    onClick: () => {
                        navigate(getRoute(`settings/scheduler/console`))
                    },
                }
            )
        }

        return props
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.requests })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle="Scheduler Requests"
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: "Scheduler Requests",
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}
